const results = [
  {
    uid: 'contributions',
    label: 'My pre-tax retirement contribution:',
    suffix: null,
    format: true,
  },
  {
    uid: 'savings',
    label: 'Federal tax savings:',
    suffix: null,
    format: true,
  },
  {
    uid: 'reductions',
    label: 'Net paycheck reduction:',
    suffix: null,
    format: true,
  },
];

export default results;



// WEBPACK FOOTER //
// ./src/config/results.js